<mat-form-field appearance="outline" class="field-control w-100">
  <mat-label>{{ label }}</mat-label>

  <input
    matInput
    [value]="value || ''"
    [placeholder]="placeholder || ''"

    (blur)="onBlur()"
    (focus)="onFocus($event)"
    (change)="onChange($event)"

    type="datetime-local"
  />

  <mat-hint class="error-hint">
    @for (error of errors; track error) {
      <span class="bg-warning-500 text-white">
        {{ error.message }}
      </span>
    }
  </mat-hint>
</mat-form-field>

